(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d-seller-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seller-code')) {
    class SellerCode extends HTMLElement {
      static value;
      static saved;
      static pending;
      static timer;
      static state = '';

      get input() {
        return this.querySelector('input');
      }

      connectedCallback() {
        if (SellerCode.value === undefined) {
          SellerCode.value = this.input.value;
          SellerCode.saved = this.input.value;
        }
        this.render();
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('input', (event) => {
          if (!event.target.matches('input')) return;
          SellerCode.value = event.target.value;
          SellerCode.state = '';
          SellerCode.renderAll();
          clearTimeout(SellerCode.timer);
          SellerCode.timer = setTimeout(() => SellerCode.save(), 500);
        });
        this.addEventListener('change', (event) => {
          event.stopPropagation();
          SellerCode.save();
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.classList.contains('d-seller-code__remove')) {
            SellerCode.value = '';
            SellerCode.renderAll();
            this.input.focus();
          }
          SellerCode.save();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || !event.target.matches('input')) return;
          event.preventDefault();
          SellerCode.save();
        });
      }

      render() {
        if (this.input.value !== SellerCode.value) this.input.value = SellerCode.value;
        this.dataset.state = SellerCode.state;
        this.input.setAttribute('aria-invalid', String(SellerCode.state === 'error'));
        this.querySelector('.d-seller-code__saved').hidden = !SellerCode.saved;
        this.querySelector('.d-seller-code__value').textContent = SellerCode.saved;
        this.querySelector('.d-seller-code__remove').disabled = SellerCode.state === 'saving';
        const button = this.querySelector('.d-seller-code__controls button');
        const unchanged = SellerCode.value === SellerCode.saved;
        button.disabled = unchanged || SellerCode.state === 'saving';
        button.textContent = unchanged && SellerCode.saved ? this.dataset.savedLabel : this.dataset.saveLabel;
        this.querySelector('.d-seller-code__status').textContent =
          this.dataset[SellerCode.state === 'saved' && !SellerCode.value ? 'removed' : SellerCode.state] || '';
      }

      static renderAll() {
        document.querySelectorAll('seller-code').forEach((field) => field.render());
      }

      static async save() {
        clearTimeout(this.timer);
        if (this.pending) return this.pending;
        this.pending = (async () => {
          try {
            while (this.value !== this.saved) {
              const value = this.value;
              this.state = 'saving';
              this.renderAll();
              const response = await fetch(`${window.routes.cart_update_url}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ attributes: { 'Código do vendedor': value } }),
              });
              if (!response.ok) throw new Error('Seller code update failed');
              const cart = await response.json();
              if ((cart.attributes?.['Código do vendedor'] || '') !== value) throw new Error('Seller code was not saved');
              this.saved = value;
            }
            this.state = 'saved';
            return true;
          } catch {
            this.state = 'error';
            return false;
          } finally {
            this.renderAll();
          }
        })();
        const result = await this.pending;
        this.pending = null;
        return result;
      }
    }

    customElements.define('seller-code', SellerCode);

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!['cart', 'CartDrawer-Form'].includes(form.id)) return;
      if (!SellerCode.pending && SellerCode.value === SellerCode.saved) return;
      event.preventDefault();
      const submitter = event.submitter;
      if (await SellerCode.save()) {
        form.requestSubmit(submitter);
      } else {
        const input = document.querySelector(`seller-code input[form="${form.id}"]`);
        const details = input?.closest('details');
        if (details) details.open = true;
        input?.focus();
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
